var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _polygon, _path20, _path21, _path22, _path23, _rect, _rect2, _rect3, _rect4, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _polygon2, _polygon3, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 273.6 98.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.8,6.3c9-4.3,15,10.4,4.7,13.2-7.9,2.2-12.5-9.5-4.7-13.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.4,63.9c9.9-5.5,15.9,10.5,4.9,12.9-7.3,1.6-11.4-9.3-4.9-12.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.6,79c6.2-3.5,11.8,5,6.7,9.4-6.4,5.5-13.8-5.4-6.7-9.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.7,17.2c7.1-4,12.2,6.4,6.2,9.8-7.3,4.1-12.2-6.5-6.2-9.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.9,5.1c5.5-3,11.2,3,7.8,8.2-3.2,4.8-10.8,2.2-10.5-3.6,0-1.7,1.2-3.7,2.8-4.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,58.2c-7-3.1-2.4-13.6,4.5-10.7,7.1,3,2.5,13.7-4.5,10.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.6,35c4.1-2.2,7.9,3.4,4.8,6.4-4.6,4.5-10.3-3.5-4.8-6.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.6,31.4c5.8-3.3,9.1,5.9,3,7.3-4.4,1-6.7-5.3-3-7.3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.9,10.7c5.2-3.1,8.8,4.4,4.3,6.8s-8.3-4.4-4.3-6.8Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40,88.5c5.5-3.1,9,5.8,3,7.4-4.4,1.1-6.9-5.2-3-7.4Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.6,44.4c3.2-2.1,5.8,3.2,2,4.3s-3.9-3-2-4.3Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.3,26.8c2.9-1.5,5.1,3,2.2,4.4s-4.9-3-2.2-4.4Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,22c-1,2.2-5,1.6-4.6-1.5.5-3.6,6.1-1.9,4.6,1.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.5,92.8c3.4-2.1,5.6,3.5,1.8,4.3s-4-3-1.8-4.3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.9,22.5c1.5-.8,3.3,1.1,2.1,2.6-1.6,2-4.5-1.4-2.1-2.6Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.7,25.8c1.9-1.2,3.4,1.5,2.1,2.6-2,1.6-4-1.4-2.1-2.6Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.7,93c2.5-1.7,4.1,2.6,1.2,2.9s-2.3-2.2-1.2-2.9Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.8,56c-2-.8-.8-3.9,1.2-3.1s.7,3.9-1.2,3.1Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.5,46.2l-5.8,2.1c-.3,0-1.7-1.8-2.1-2.1-8.7-7.2-20.1,3.6-13.6,12.7,3.6,5,10.2,5.1,14.4.9s1-1.6,1.4-1.6l5.7,2.3c-1.5,2.9-4.2,5.3-7.2,6.7-13.2,6-27.8-7.5-20.9-20.7,5.8-11.1,22.3-11.1,28.2-.2Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.3,68v-2s-2.3,1.5-2.3,1.5c-9.7,3.8-17.4-4-15.2-13.9,1.8-8,11.5-11,17.5-5.6v-2.1h5.9v22.1h-5.9ZM223.5,50.7c-7.9.9-6.7,14.1,2.4,12.4,6.9-1.3,5.9-13.3-2.4-12.4Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.7,59.4h-17.4c.3,3.6,5.6,4.6,8.4,3.6s2.2-1.4,3.3-2.1l4.5,2.5c.2.3-1.2,1.8-1.5,2-6.7,6.3-20.1,3.2-20.8-6.7-.5-6.1,2.1-10.8,8.1-12.5,8.9-2.6,16.9,3.9,15.3,13.3ZM93.5,55.1h10.7c.4,0,0-.7,0-.9-1.7-5-10.2-4.4-10.8.9Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "161.2 38.6 169.2 54.8 177.3 38.6 184 38.6 169.3 68.7 154.7 38.6 161.2 38.6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.3,68h-6.2v-14c0-.3-.4-1.5-.6-1.8-1.5-2.6-6.1-2.1-7.3.6s-.6,1.7-.6,2v13.2h-6.1v-22.1h6.1v1.8c2.7-2.2,5.8-2.7,9.1-1.9s5.4,4.6,5.6,8.3c.3,4.5-.2,9.3,0,13.8Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.4,45.5c3.6-.2,7.2,1,10,3.2l-3.2,4.1c-2.1-1.3-6-2.8-8.3-1.5s-1,1.9.3,2.5c3.5,1.4,7.9.4,10.6,3.8,1.9,2.3,1.5,6.7-.6,8.8-3.9,3.9-13.7,2.6-17.6-1.1,0-.2,0-.3.1-.5.2-.4,2.7-3.6,2.9-3.7,2,1.4,8.6,3.7,10.1,1.1.8-1.4-.5-1.9-1.6-2.2-3.7-.9-9.6-.8-10.9-5.5-1.7-5.9,2.9-8.6,8.1-9Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.8,45.4h4.2l.2.2v5.2h-4.4v10.6c0,.1.6,1.4.7,1.5s1.1.5,1.2.5h2.4v5.1c-3,0-7.8.7-9.6-2.3s-.7-1.8-.7-2.2v-13.2h-2.6v-5.4h2.6v-5.9h5.8l.2.2v5.7Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.9,39.5v5.9h4.4v5.4h-4.4v10.1c0,.2.4,1.3.5,1.5.7,1.3,2.6,1,3.8,1v5.1l-3.4.2c-1.9-.3-4.3-.2-5.7-1.7s-1.1-1.9-1.1-2.5v-13.7h-2.8v-5.2l.2-.2h2.5v-5.9h5.9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 241.2,
    y: 37.6,
    width: 6.1,
    height: 30.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 65.6,
    y: 37.6,
    width: 6.1,
    height: 30.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 186.3,
    y: 45.9,
    width: 6.1,
    height: 22.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 77,
    y: 45.9,
    width: 6.1,
    height: 22.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.4,37.1c5-.8,5.4,6.5.6,6.5-4.1,0-4.4-5.8-.6-6.5Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.7,37.1c4.9-.8,5.5,6.5.6,6.5s-4.3-5.8-.6-6.5Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.3,75.5c1,1.6,2.1,3.7,3.3,5.2s0,.3.3.2v-5.4h1.7v8.7h-1.8s-3.9-6-3.9-6v6s-1.7,0-1.7,0v-8.7s2.1,0,2.1,0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.7,75.4c6.8-1.1,7.6,8.1,1.7,8.9s-7.1-8.1-1.7-8.9ZM110.9,81.9c2.7-2.5-1.2-6.9-4.1-4.2-2.7,2.6,1.2,6.9,4.1,4.2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.8,76.6c4.2-4.2,10.9,2,6.7,6.3-4.3,4.4-11-2-6.7-6.3ZM174,77.8c-2.8,3,2.1,6.9,4.5,3.8s-2-6.4-4.5-3.8Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.3,75.5v5.5c0,0,.3.7.4.8.9,1.3,3.2,1.1,3.8-.4s.2-.9.2-1v-4.9h1.7v5.6c0,.5-.8,1.9-1.2,2.2-2.4,2.3-6.6.4-6.6-2.8v-5h1.8Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.1,75.3c1,0,2.3.3,2.9,1.1l-1.1,1.1c-.7-.6-2.5-1-2.9.2s3.3,1.6,4,3.1c1.7,3.6-4.1,4.9-6,2.4l1.1-1.1c.7.6,3,1.3,3.3,0s-3.7-1.5-4.2-3.5.9-3.2,2.8-3.3Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.8,76.1l-1,1.3c-.2,0-1.8-1.2-2.6-.2-1.2,1.4,2,2,2.8,2.6,2.3,1.6,1,4.5-1.6,4.6s-2.9-.4-3.3-1.1.8-1.1,1.1-1.3c.7.7,3.2,1.3,3.2-.1s-3.8-1.3-4.2-3.5c-.6-3.3,3.6-3.8,5.7-2.3Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "155 75.5 155 77 152.6 77 152.6 84.3 150.8 84.3 150.8 77 148.4 77 148.4 75.5 155 75.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "122.7 75.5 122.7 82.4 122.9 82.6 126.9 82.6 126.9 84.3 121 84.3 121 75.5 122.7 75.5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 162.2,
    y: 75.5,
    width: 1.8,
    height: 8.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.8b68a57691806e06edcd7b313d247cee.svg";
export { ForwardRef as ReactComponent };